var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#FF8E7F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 24C26.4008 20.448 24.0008 15.6 22.8008 14.4C22.8008 18.0456 20.6732 20.0892 19.2008 21.6C17.7296 23.112 16.8008 25.488 16.8008 27.6C16.8008 29.5096 17.5594 31.3409 18.9096 32.6912C20.2599 34.0415 22.0912 34.8 24.0008 34.8C25.9103 34.8 27.7417 34.0415 29.092 32.6912C30.4422 31.3409 31.2008 29.5096 31.2008 27.6C31.2008 25.7616 29.9336 22.872 28.8008 21.6C26.6576 25.2 25.4516 25.2 24.0008 24Z",
    stroke: "#F55843",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.221962d2b2486d5c839f0720a96db047.svg";
export { ForwardRef as ReactComponent };